export const META_TAGS = {
  title: `Link3.to | A Web3 Social Network of Verifiable Identities`,
  description: `Link3 is a Web3 native social platform built on CyberConnect protocol.`,
  image: process.env.NEXT_PUBLIC_APP_URL + 'meta/opengraph.png',
};
